export default function Section({ title, children }) {
  return (
    <div className="test-section">
      <h4>{title}</h4>
      {children}
    </div>
  );
}